export default "__VITE_ASSET__DSLQwt2f__"